import React, {PropsWithChildren, useEffect, useState} from "react";
import {ModalProps, ModalWithHeaderProps} from "../../types";
import ArrowLeftIcon from "../../assets/icon/ArrowLeftIcon";
import {CloseRoundIcon} from "../../assets/icon";
import {useDownMd} from "../../hooks/useLayout";
import Overlay from "../Overlay";
import { Button } from "components";
import { useIntl } from "react-intl";

export default function Modal({
                                  children,
                                  isOpen,
                                  width = 480,
                                  zIndex = 100,
                                  className = ''
                              }: ModalProps) {

    return <Overlay isOpen={isOpen} zIndex={zIndex}>
        <div className={`matchid-modal ${className}`} style={{
            width
        }}>
            <div className="matchid-modal-mobile-header"></div>
            {children}
        </div>
    </Overlay>
}

export function ModalWithHeader({
                                    children,
                                    onBack,
                                    onClose,
                                    title,
                                    showBorder = true,
                                    showClose = true,
                                    ...props

                                }: ModalWithHeaderProps) {
    const isDownMd = useDownMd()
    return <Modal {...props}>
        <div className={`matchid-modal-header ${showBorder ? 'matchid-modal-header-border' : ''}`}>
            <div className="matchid-modal-header-content">
                {
                    onBack &&
                    <ArrowLeftIcon height={isDownMd ? 20 : 25} width={isDownMd ? 20 : 24} className="matchid-modal-header-back" onClick={onBack}/>
                }
                <span className="matchid-modal-header-title">{title}</span>
            </div>
            {onClose &&
                <CloseRoundIcon size={isDownMd ? 24 : 30} className="matchid-modal-header-close" onClick={onClose}/>}
        </div>
        {children}
    </Modal>

}

export function ConfirmModal({
                                 title,
                                 children,
                                 onClose,
                                 onConfirm,
                                 isOpen,
                                 confirmText,
    zIndex=100
                             }: {
    title?: string
    onClose: () => void,
    onConfirm: () => Promise<void>,
    isOpen: boolean,
    confirmText?: React.ReactNode,
    zIndex?:number
} & PropsWithChildren) {
    const intl = useIntl()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    useEffect(() => {
        if (isOpen) {
            setError('')
            setLoading(false)
        }
    }, [isOpen]);
    const onSubmit = async () => {
        setError('')
        setLoading(true)
        try {
            await onConfirm()
        } catch (e: any) {
            setError(e.message)
            console.error(e)
        } finally {
            setLoading(false)
        }
    }

    return <ModalWithHeader isOpen={isOpen} onClose={onClose} title={title} zIndex={zIndex}>
        <div className="matchid-confirm-modal">
            <div className="matchid-w-full">{children}</div>
            {error && <div className={`matchid-error`}>{error}</div>}
            <Button size={"lg"} onClick={onSubmit} loading={loading} block highlight>{confirmText ?? intl.formatMessage({
                id:"Confirm"
            })}</Button>
        </div>
    </ModalWithHeader>
}